import { MouseEvent, useState } from 'react';

interface Props {
  src: string | undefined;
  alt: string;
  className?: string;
}

const NIVEL_ZOOM = 2.2;

/**
 * Imagen con "lupa": al pasar el mouse, se amplia siguiendo la posicion del
 * cursor dentro del mismo recuadro (sin panel flotante ni libreria externa).
 * Es un efecto de solo-desktop (depende de mousemove) — en touch/mobile se ve
 * la imagen normal, igual que antes de este componente.
 */
export function ZoomableImage({ src, alt, className = '' }: Props) {
  const [activo, setActivo] = useState(false);
  const [posicion, setPosicion] = useState({ x: 50, y: 50 });

  const alMoverMouse = (evento: MouseEvent<HTMLDivElement>) => {
    const recuadro = evento.currentTarget.getBoundingClientRect();
    const x = ((evento.clientX - recuadro.left) / recuadro.width) * 100;
    const y = ((evento.clientY - recuadro.top) / recuadro.height) * 100;
    setPosicion({ x: Math.min(100, Math.max(0, x)), y: Math.min(100, Math.max(0, y)) });
  };

  return (
    <div
      className={`relative overflow-hidden bg-terracotta/20 ${className} ${src ? 'cursor-zoom-in' : ''}`}
      onMouseEnter={() => src && setActivo(true)}
      onMouseLeave={() => setActivo(false)}
      onMouseMove={src ? alMoverMouse : undefined}
      role="img"
      aria-label={alt}
      data-testid="imagen-principal"
    >
      {src && (
        <div
          className="absolute inset-0 bg-center bg-cover transition-transform duration-150 ease-out"
          data-testid="imagen-principal-capa-zoom"
          style={{
            backgroundImage: `url(${src})`,
            transform: activo ? `scale(${NIVEL_ZOOM})` : 'scale(1)',
            transformOrigin: `${posicion.x}% ${posicion.y}%`,
          }}
        />
      )}
    </div>
  );
}
